var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApprove = function SvgApprove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#44AC21",
    d: "M6 11.25A5.25 5.25 0 1 1 6 .75a5.25 5.25 0 0 1 0 10.5M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#44AC21",
    d: "m8.227 3.727-.015.017-2.604 3.319-1.57-1.57a.563.563 0 0 0-.796.795l1.985 1.985a.56.56 0 0 0 .81-.016L9.03 4.515a.563.563 0 0 0-.804-.788"
  })));
};
export default SvgApprove;